import { FC, ReactNode, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  rootId: string;
  children: ReactNode | ((targetEl: HTMLElement | null) => ReactNode);
}

const Portal: FC<Props> = ({ rootId, children }) => {
  const target = useRef(document.getElementById(rootId));

  useEffect(() => {
    return () => {
      window.requestAnimationFrame(() => {
        if (target.current?.childNodes.length === 0) {
          target.current.remove();
          target.current = null;
        }
      });
    };
  }, [rootId]);

  if (!target.current) {
    target.current = document.createElement('div');
    target.current.setAttribute('id', rootId);
    document.body.appendChild(target.current);
  }

  if (typeof children === 'function') {
    return createPortal(children(target.current), target.current);
  }

  return createPortal(children, target.current);
};

export default Portal;
